<template>
	<div id="event-success-page">
		<div class="container">
			<aside v-if="evento">
				<img src="../assets/ticketin/Defecto.svg" alt="" class="ticketin">
				<div class="aside-wrapper">
					<div class="aside-top" :style="{ 'background-image': 'url(' + evento.Evento.EventoFotoPrincipal + ')' }">
						<span class="evento-title">{{ evento.Evento.EventoNombre }}</span>
						<div class="aside-top-info">
							<img class="evento-foto" :src="evento.Evento.EventoFotoPrincipal" :alt="evento.Evento.EventoNombre">
							<div class="aside-top-info-right">
								<span class="evento-info-categoria">{{ evento.Categorias.EventoCategoriaNombre }}</span>
								<span class="evento-info-fecha">{{ evento.Fecha.EventoFechaHoraEscrita }}</span>
								<span class="evento-info-escenario">{{ evento.Escenario.EscenarioNombre }}</span>
							</div>
						</div>
					</div>
					<div class="aside-main">
						<div class="aside-row">
							<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
								<circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
								<path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
							</svg>
						</div>
						<div class="aside-row">
							<h2>¡Compra realizada con éxito!</h2>
						</div>
						<div class="aside-row" v-if="!loggedIn">
							<p>Tus tickets fueron emitidos correctamente, a la brevedad los recibirás por correo electrónico.</p>
						</div>
						<div class="aside-row" v-if="loggedIn">
							<p>Tus tickets fueron emitidos correctamente, puedes encontrarlos en la sección "Mis tickets". A su vez, también te los hemos enviado por correo electrónico.</p>
						</div>
						<div class="aside-row" v-if="loggedIn">
							<router-link :to="{ name: 'mis-tickets' }" class="btn">Ver mis tickets</router-link>
						</div>
					</div>
				</div>
			</aside>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { mapState }  from 'vuex';

	export default {
		data(){
			return{
				eventoId: null,
				transaccionId: null,
				pagoExternoId: null,
				evento: null
			}
		},
		metaInfo: {
			title: '¡Compra exitosa!',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		computed: {
			...mapState('AuthModule', ['loggedIn'])
		},
		async mounted() {
			this.$store.dispatch('cargando', true);

			// http://localhost:8081/pago-exitoso?external_reference=29-144&payment_id=123&status=approved&preference_id=444
		
			if(this.$route.query.external_reference && this.$route.query.payment_id && this.$route.query.status === 'approved' && this.$route.query.preference_id){
				let eve_tran = this.$route.query.external_reference.split('-')

				if(eve_tran.length === 6){
					this.eventoId = eve_tran[0]
					eve_tran.shift()
					this.transaccionId = eve_tran.join('-')
					this.pagoExternoId = this.$route.query.payment_id
				} else {
					this.$router.push({ name: 'error' });
				}
			} else {
				this.$router.push({ name: 'error' });
			}

			await this.getEvento();

			this.$store.dispatch('cargando', false);
		},
		methods: {
			async getEvento(){
				try {
					let response = await axios.post('/WSEventoNoSlug', {
						EventoId: this.eventoId
					});

					if(response.data.ErrorCod === 0){
						this.evento = response.data.SDTEvento
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error inesperado.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error inesperado.')
					this.$router.push({ name: 'error' });
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	#event-success-page{
		background-color: var(--color-white);
		@include flex(column, flex-start, center);
		padding: 60px 0px;
		// min-height: calc(100vh - 80px);

		.container{
			@include flex(column, flex-start, center);

			aside{
				position: relative;
				width: 440px;
				@include flex(column, flex-start, center);
			
				.ticketin{
					position: absolute;
					width: 140px;
					left: -120px;
					bottom: 0px;
				}

				.aside-wrapper{
					position: relative;
					@include flex(column, flex-start, flex-start);
					border-radius: 22px;
					box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 16px;
					border: 1px solid rgba(0, 0, 0, 0.1);

					.aside-top{
						width: 100%;
						border-radius: 22px 22px 0px 0px;
						@include flex(column, flex-start, flex-start);
						position: relative;
						padding: 30px 30px 76px 30px;
						background-color: var(--color-darker);
						background-position: center;
						background-size: cover;
						background-repeat: no-repeat;

						.evento-title{
							color: var(--color-white);
							font-family: var(--font-sora);
							font-weight: var(--fw-700);
							font-size: 22px;
							line-height: 1.4em;
							z-index: 2;
						}

						.aside-top-info{
							position: absolute;
							width: calc(100% - 60px);
							height: 112px;
							bottom: -56px;
							left: 30px;
							background-color: var(--color-white);
							// z-index: 99;
							border-radius: 12px;
							padding: 14px;
							box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 22px;
							z-index: 10;
							@include flex(row, flex-start, center);

							.evento-foto{
								border-radius: 12px;
								height: 80px;
								width: 80px;
								object-fit: cover;
								margin-right: 20px;
							}

							.aside-top-info-right{
								@include flex(column, center, flex-start);

								.evento-info-categoria{
									font-weight: var(--fw-700);
									line-height: 1em;
									font-size: 12px;
								}

								.evento-info-fecha{
									font-weight: var(--fw-400);
									line-height: 1em;
									margin-top: 5px;
									font-size: 13px;
								}

								.evento-info-escenario{
									font-weight: var(--fw-400);
									line-height: 1em;
									margin-top: 5px;
									font-size: 13px;
								}
							}
						}

						&:before{
							content: '';
							position: absolute;
							background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.3));
							top: 0;
							left: 0;
							width: 100%;
							height: 100%;
							z-index: 0;
							border-radius: 22px 22px 0px 0px;
						}
					}

					.aside-main{
						width: 100%;
						@include flex(column, flex-start, flex-start);
						padding: 80px 30px 30px 30px;
						position: relative;
						z-index: 4;

						.aside-row{
							width: 100%;
							@include flex(row, space-between, center);
							

							&.aside-row-centered{
								@include flex(row, center, center);
							}

							h2{
								font-size: 20px;
								font-weight: var(--fw-700);
								font-family: var(--font-sora);
								width: 100%;
								text-align: center;
							}

							p{
								font-size: 13px;
								margin: 8px 0px 12px 0px;
								text-align: center;
							}

							.checkmark__circle {
								stroke-dasharray: 166;
								stroke-dashoffset: 166;
								stroke-width: 2;
								stroke-miterlimit: 10;
								stroke: #7ac142;
								fill: none;
								animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
							}

							.checkmark {
								width: 56px;
								height: 56px;
								border-radius: 50%;
								display: block;
								stroke-width: 2;
								stroke: #fff;
								stroke-miterlimit: 10;
								margin: 0 auto;
								margin-bottom: 20px;
								box-shadow: inset 0px 0px 0px #7ac142;
								animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
							}

							.checkmark__check {
								transform-origin: 50% 50%;
								stroke-dasharray: 48;
								stroke-dashoffset: 48;
								animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
							}

							@keyframes stroke {
								100% {
									stroke-dashoffset: 0;
								}
							}
							@keyframes scale {
								0%, 100% {
									transform: none;
								}
								50% {
									transform: scale3d(1.1, 1.1, 1);
								}
							}
							@keyframes fill {
								100% {
									box-shadow: inset 0px 0px 0px 30px #7ac142;
								}
							}

							.divider{
								position: relative;
								width: 100%;
								height: 1px;
								border-top: 1px dashed rgba(0, 0, 0, 0.25);
								margin: 16px 0px;
							}

							.btn{
								text-decoration: none;
								@include flex(row, center, center);
								width: 100%;
								background-color: #222222;
								border: 1px solid #222222;
								border-radius: 8px;
								outline: none;
								padding: 13px 22px;
								color: var(--color-white);
								font-size: 14px;
								font-weight: var(--fw-600);
								font-family: var(--font-sora);
								line-height: 1.4em;
								letter-spacing: 1px;
								margin: 8px 0px 0px 0px;
								@include transition(all 0.2s);
								cursor: pointer;

								&:hover {
									background-color: var(--color-primary);
									border: 1px solid #222222;
									color: #222222;
									transform: translate(-0.25rem, -0.25rem);
									box-shadow: 0.25rem 0.25rem 0 #222222;
								}
							}
						}
					}
				}
			}

			.evento-loader{
				padding: 60px 40px 60px 0px;
				@include flex(row, center, center);
				width: 100%;
			}
		}
	}

	@media screen and (max-width: 754px){
		#event-success-page{
			padding: 30px 0px;

			.container{
				padding-left: 24px;
				padding-right: 24px;

				aside{
					.ticketin{
						display: none;
					}
				}
			}
		}
	}

	@media screen and (max-width: 536px){
		#event-success-page{
			.container{
				aside{
					width: 100%;
					margin: 0;

					.aside-wrapper{
						.aside-top{
							padding: 20px 20px 56px 20px;

							.evento-title{
								font-size: 18px;
							}

							.aside-top-info{
								height: 92px;
								bottom: -46px;
								width: calc(100% - 40px);
								left: 20px;
								padding: 12px;

								.evento-foto{
									width: 68px;
									height: 68px;
									border-radius: 8px;
									margin-right: 12px;
								}

								.aside-top-info-right{
									.evento-info-categoria{
										font-size: 11px;
									}

									.evento-info-fecha{
										font-size: 12px;
									}

									.evento-info-escenario{
										font-size: 12px;
									}
								}
							}
						}

						.aside-main{
							padding: 80px 20px 20px 20px;

							.aside-row{
								.resumen-text{
									font-size: 15px;
									margin-bottom: 12px;
								}

								h2{
									font-size: 16px;
								}

								p{
									font-size: 12px;
								}

								.btn{
									padding: 11px 20px;
									font-size: 13px;
								}
							}
						}
					}
				}
			}
		}
	}
</style>